/**
 * Modal pub marketing Access — court, percutant, CTA « Commencer ».
 */
import React from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';

const GS_LOGO = '/emoji/logoapp1.png';

const GLASS = {
  background: 'linear-gradient(135deg, rgba(74,144,226,0.22) 0%, rgba(30,60,140,0.38) 55%, rgba(10,20,80,0.52) 100%)',
  backdropFilter: 'blur(40px) saturate(280%) brightness(1.1)',
  WebkitBackdropFilter: 'blur(40px) saturate(280%) brightness(1.1)',
  border: '1.5px solid rgba(107,163,232,0.45)',
  boxShadow: '0 24px 64px rgba(0,0,0,0.55), 0 0 48px rgba(74,144,226,0.2), inset 0 1px 0 rgba(255,255,255,0.22)',
};

export default function AccessPubModal({ open, onClose, onCommencer, userName }) {
  if (typeof document === 'undefined' || !document.body) return null;

  const firstName = String(userName || '').trim().split(/\s+/)[0];

  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div
          key="access-pub"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{
            position: 'fixed', inset: 0, zIndex: 'var(--gs-z-lock, 4000)',
            background: 'rgba(5,10,28,0.78)',
            backdropFilter: 'blur(14px)',
            WebkitBackdropFilter: 'blur(14px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: 'max(16px, env(safe-area-inset-top)) 18px max(16px, env(safe-area-inset-bottom))',
          }}
          onClick={onClose}
        >
          <motion.div
            initial={{ scale: 0.92, y: 20, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 380, damping: 32 }}
            onClick={(e) => e.stopPropagation()}
            style={{
              ...GLASS,
              width: '100%',
              maxWidth: 380,
              borderRadius: 26,
              padding: '28px 22px 22px',
              textAlign: 'center',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <div
              aria-hidden
              style={{
                position: 'absolute', top: -60, right: -40, width: 160, height: 160, borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(74,144,226,0.35), transparent 70%)',
                pointerEvents: 'none',
              }}
            />
            <div
              aria-hidden
              style={{
                position: 'absolute', bottom: -50, left: -30, width: 140, height: 140, borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(107,163,232,0.2), transparent 70%)',
                pointerEvents: 'none',
              }}
            />

            <img
              src={GS_LOGO}
              alt="Global Strains"
              style={{
                width: 92, height: 92, objectFit: 'contain', margin: '0 auto 14px',
                filter: 'drop-shadow(0 10px 28px rgba(251, 191, 36, 0.4))',
                position: 'relative', zIndex: 1,
              }}
            />

            <p style={{
              margin: '0 0 6px', fontSize: 10, fontWeight: 800, letterSpacing: '0.2em',
              textTransform: 'uppercase', color: 'rgba(147,197,253,0.85)', position: 'relative', zIndex: 1,
            }}>
              Global Strains Access
            </p>

            <h2 style={{
              margin: '0 0 10px', fontSize: 22, fontWeight: 900, lineHeight: 1.2,
              color: '#fff', position: 'relative', zIndex: 1,
            }}>
              {firstName ? `${firstName}, prêt à` : 'Prêt à'} débloquer{' '}
              <span style={{
                background: 'linear-gradient(135deg, #fde68a 0%, #fbbf24 50%, #fb923c 100%)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
              }}>
                la boutique
              </span>
              ?
            </h2>

            <p style={{
              margin: '0 0 8px', fontSize: 13, lineHeight: 1.55, color: 'rgba(191,219,254,0.82)',
              position: 'relative', zIndex: 1,
            }}>
              Commande, panier, livraison — tout en un clic après activation.
            </p>
            <p style={{
              margin: '0 0 22px', fontSize: 12, fontWeight: 700, color: 'rgba(134,239,172,0.9)',
              position: 'relative', zIndex: 1,
            }}>
              +60 Global Coins offerts à l&apos;inscription
            </p>

            <button
              type="button"
              onClick={() => {
                try { window.Telegram?.WebApp?.HapticFeedback?.impactOccurred?.('medium'); } catch { /* */ }
                if (typeof onCommencer === 'function') onCommencer();
              }}
              style={{
                width: '100%', padding: '16px 20px', borderRadius: 16, border: 'none',
                background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 45%, #ea580c 100%)',
                color: '#1c1917', fontWeight: 900, fontSize: 16, letterSpacing: '0.02em',
                cursor: 'pointer', marginBottom: 10, position: 'relative', zIndex: 1,
                boxShadow: '0 10px 32px rgba(245,158,11,0.45), inset 0 1px 0 rgba(255,255,255,0.45)',
              }}
            >
              Commencer
            </button>

            <button
              type="button"
              onClick={onClose}
              style={{
                width: '100%', padding: '11px 16px', borderRadius: 12,
                border: '1px solid rgba(107,163,232,0.28)', background: 'rgba(255,255,255,0.06)',
                color: 'rgba(191,219,254,0.75)', fontWeight: 700, fontSize: 13, cursor: 'pointer',
                position: 'relative', zIndex: 1,
              }}
            >
              Plus tard
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
}
